import * as React from "react";
import { Slot } from "@radix-ui/react-slot";
import { cva } from "class-variance-authority";
import { cn } from "@/lib/utils";

const buttonV2Variants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap font-medium transition-all duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 touch-manipulation",
  {
    variants: {
      variant: {
        primary:
          "bg-brand text-white shadow-v2-md hover:bg-brand/90 hover:shadow-v2-lg active:bg-brand/95",
        gradient:
          "bg-gradient-to-r from-brand via-brand-accent to-brand text-white shadow-v2-glow hover:brightness-110 active:brightness-95",
        secondary:
          "border border-v2-border bg-v2-surface text-v2-foreground shadow-v2-sm hover:border-brand/30 hover:shadow-v2-md active:bg-v2-background",
        ghost:
          "text-v2-foreground hover:bg-v2-background active:bg-v2-background",
        link: "text-brand underline-offset-4 hover:underline p-0 h-auto min-h-0 min-w-0",
      },
      size: {
        sm: "h-10 min-h-[44px] rounded-full px-5 text-sm",
        default: "h-11 min-h-[44px] rounded-full px-6 text-sm",
        lg: "h-12 min-h-[48px] rounded-full px-7 text-base",
        xl: "h-14 min-h-[48px] rounded-full px-8 sm:px-9 text-base w-full sm:w-auto",
      },
    },
    defaultVariants: {
      variant: "primary",
      size: "default",
    },
  }
);

const ButtonV2 = React.forwardRef(
  ({ className, variant, size, asChild = false, ...props }, ref) => {
    const Comp = asChild ? Slot : "button";
    return (
      <Comp
        className={cn(buttonV2Variants({ variant, size, className }))}
        ref={ref}
        {...props}
      />
    );
  }
);
ButtonV2.displayName = "ButtonV2";

export { ButtonV2, buttonV2Variants };
